import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=600691a0&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=600691a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600691a0",
  null
  
)

export default component.exports